export const MAXIMUM_INLINE_IMAGE_BYTES = 5_000_000
export const INLINE_IMAGE_ACCEPT = 'image/png,image/jpeg,image/gif,image/webp'

export function inlineImageContentType(bytes: Uint8Array): string | null {
  if (bytes.length < 12 || bytes.length > MAXIMUM_INLINE_IMAGE_BYTES)
    return null
  const begins = (signature: number[], offset = 0) =>
    signature.every((value, index) => bytes[offset + index] === value)
  if (begins([137, 80, 78, 71, 13, 10, 26, 10])) return 'image/png'
  if (begins([255, 216, 255])) return 'image/jpeg'
  if (begins([71, 73, 70, 56, 55, 97]) || begins([71, 73, 70, 56, 57, 97]))
    return 'image/gif'
  if (begins([82, 73, 70, 70]) && begins([87, 69, 66, 80], 8))
    return 'image/webp'
  return null
}

export function messageImageHtml(
  html: string,
  filePath: string,
  orderId?: number,
  browserContext?: string
) {
  // The backend emits only these private attachment references in published HTML.
  return html.replace(
    /src="cid:support-file-([a-f0-9]{32})"/g,
    (_, hex: string) => {
      const id = `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`
      return `src="${filePath}/${id}?inline=1${orderId ? `&amp;order=${orderId}` : ''}${browserContext ? `&amp;context=${encodeURIComponent(browserContext)}` : ''}" loading="lazy" referrerpolicy="no-referrer"`
    }
  )
}
